import React from "react"
import {FieldViewProps} from "../../../../render/view"

// import PropertyGray from "../../../../../gd-components/properties/property-gray/property-gray"
import PriorityIcon from "../../../../../gd-components/priority/priority-icon/priority-icon"

export default function FieldTaskPriority_ViewProperty(props: FieldViewProps) {

    const value = props.field.getViewValue(props.model)

    const classes = Classes("flex-row-left-center flex-no-shrink border-box p-l-6 p-r-6 h-22", props.className)

    return (
        <div className={classes}>
            <PriorityIcon className="size-15 m-t-2" priority={value}/>
        </div>
    )

    /*return (
        <PropertyGray className={props.className}>
            <PriorityIcon className="size-15 m-t-2" priority={value}/>
        </PropertyGray>
    )*/
}